const symbolList = new Array(451).fill('').map((e, i) => String.fromCharCode(i + 195)).join('');

const beadEncodingSymbols = (() => {
    const result = {};
    symbolList.split('').forEach((letter, i) => {
        result[i] = letter;
    });
    return result;
})();

const beadDecodingSymbols = (() => {
    const result = {};
    symbolList.split('').forEach((letter, i) => {
        result[letter] = i;
    });
    return result;
})();

const lookup = num => num <= 450 ? beadEncodingSymbols[num] : num;
const encode = entry => `${lookup(entry.style)},${lookup(entry.row)},${lookup(entry.column)}`;
const shorten = str => str.length === 5 ? `${str[0]}${str[2]}${str[4]}` : str;

export const compress = arr => arr
    .map(bead => shorten(encode(bead)))
    .join(';');


const mySplit = str => str.split(';');
const lengthen = str => str.includes(',') ? str : str.split('').join(',');
const decode = str => beadDecodingSymbols[str] ?? Number(str);

const convert = str => {
    const arr = str.split(',');
    return {
        style: decode(arr[0]),
        row: decode(arr[1]),
        column: decode(arr[2])
    }
};

const decompress = str => mySplit(str)
    .map(element => lengthen(element))
    .map(element => convert(element));

export const decompressFile = file => {
    if (file.beadString !== undefined) {
        file.beads = decompress(file.beadString);
    }
    if (typeof file.settings.offset === 'string') {
        file.settings.offset = file.settings.offset
            .split('')
            .map(element => Number(element));
    }
    return file;
};
